var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass:
        "bg-white px-3 py-3 flex items-center justify-between border-t border-gray-200 sm:px-3",
    },
    [
      _vm._m(0),
      _c(
        "div",
        {
          staticClass:
            "hidden sm:flex-1 sm:flex sm:items-center sm:justify-between",
        },
        [
          _c("div", [
            _c("p", { staticClass: "text-sm leading-5 text-gray-700" }, [
              _vm._v(" Showing "),
              _c("span", { staticClass: "font-medium" }, [
                _vm._v(_vm._s(_vm.resultFromValue)),
              ]),
              _vm._v(" to "),
              _c("span", { staticClass: "font-medium" }, [
                _vm._v(_vm._s(_vm.resultToValue) + " "),
              ]),
              _vm._v(" of "),
              _c("span", { staticClass: "font-medium" }, [
                _vm._v(_vm._s(_vm.total)),
              ]),
              _vm._v(" results "),
            ]),
          ]),
          _vm._t("dropdown"),
          _c("div", [
            _c("nav", { staticClass: "relative z-0 inline-flex shadow-sm" }, [
              _c(
                "button",
                {
                  staticClass:
                    "cursor-pointer relative inline-flex items-center px-2 py-2 rounded-l-md border border-gray-300 bg-white text-sm leading-5 font-medium text-gray-500 hover:text-gray-400 focus:z-10 focus:outline-none focus:border-primary active:bg-gray-100 active:text-gray-500 transition ease-in-out duration-150 disabled:bg-cool-gray-100 disabled:text-gray-300",
                  attrs: {
                    disabled: _vm.resultFrom === 1,
                    "aria-label": "Previous",
                  },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.$emit("prev")
                    },
                  },
                },
                [
                  _c(
                    "svg",
                    {
                      staticClass: "h-5 w-5",
                      attrs: { viewBox: "0 0 20 20", fill: "currentColor" },
                    },
                    [
                      _c("path", {
                        attrs: {
                          "fill-rule": "evenodd",
                          d: "M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z",
                          "clip-rule": "evenodd",
                        },
                      }),
                    ]
                  ),
                ]
              ),
              _c(
                "button",
                {
                  staticClass:
                    "cursor-pointer -ml-px relative inline-flex items-center px-2 py-2 rounded-r-md border border-gray-300 bg-white text-sm leading-5 font-medium text-gray-500 hover:text-gray-400 focus:z-10 focus:outline-none focus:border-primary active:bg-gray-100 active:text-gray-500 transition ease-in-out duration-150 disabled:bg-cool-gray-100 disabled:text-gray-300",
                  attrs: {
                    disabled: _vm.resultTo >= _vm.total,
                    "aria-label": "Next",
                  },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.$emit("next")
                    },
                  },
                },
                [
                  _c(
                    "svg",
                    {
                      staticClass: "h-5 w-5",
                      attrs: { viewBox: "0 0 20 20", fill: "currentColor" },
                    },
                    [
                      _c("path", {
                        attrs: {
                          "fill-rule": "evenodd",
                          d: "M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z",
                          "clip-rule": "evenodd",
                        },
                      }),
                    ]
                  ),
                ]
              ),
            ]),
          ]),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "flex-1 flex justify-between sm:hidden" }, [
      _c(
        "a",
        {
          staticClass:
            "relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm leading-5 font-medium rounded-md text-gray-700 bg-white hover:text-gray-500 focus:outline-none focus:border-primary active:bg-gray-100 active:text-gray-700 transition ease-in-out duration-150",
          attrs: { href: "#" },
        },
        [_vm._v("Previous")]
      ),
      _c(
        "a",
        {
          staticClass:
            "ml-3 relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm leading-5 font-medium rounded-md text-gray-700 bg-white hover:text-gray-500 focus:outline-none focus:border-primary active:bg-gray-100 active:text-gray-700 transition ease-in-out duration-150",
          attrs: { href: "#" },
        },
        [_vm._v("Next")]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }